import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import localhost from "apis/localhost";

export const RESET_STORE_ACTION = "session/resetStore";

export const resetStore = () => ({ type: RESET_STORE_ACTION });

export const extendSession = createAsyncThunk("session/extend", async () => {
  const rsp = await localhost.post("/api/session/extend", {});
  return rsp?.data || {};
});

export const fetchSessionConfig = createAsyncThunk("session/config", async () => {
  try {
    const rsp = await localhost.get("/api/session/config", {
      skipAuthRedirect: true,
    });
    return rsp?.data || {};
  } catch {
    // Setup/first-user flows can 403 this non-critical endpoint before the
    // session is fully established. Fall back to defaults with the feature
    // disabled instead of breaking the flow.
    return { enabled: false };
  }
});

const applySessionConfig = (state, payload) => {
  state.enabled = payload?.enabled ?? state.enabled;
  state.timeoutSeconds = payload?.timeoutSeconds ?? state.timeoutSeconds;
  state.warningLeadSeconds = payload?.warningLeadSeconds ?? state.warningLeadSeconds;
};

const initialState = {
  expiresAt: null,
  skew: 0,
  enabled: false,
  timeoutSeconds: 1800,
  warningLeadSeconds: 120,
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    updateExpiry: (state, { payload }) => {
      if (payload?.expiresAt && (state.expiresAt == null || payload.expiresAt > state.expiresAt)) {
        state.expiresAt = payload.expiresAt;
        state.skew = payload.skew ?? state.skew;
      }
    },
    setSessionConfig: (state, { payload }) => applySessionConfig(state, payload),
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSessionConfig.fulfilled, (state, { payload }) =>
      applySessionConfig(state, payload)
    );
  },
});

export const { updateExpiry, setSessionConfig } = sessionSlice.actions;

export default sessionSlice.reducer;
